import React from 'react'
import DropdownTableData from './DropdownTableData'
import FixedTextTableData from '../../components/tableComponents/FixedTextTableData'
import VariableTextTableData from '../../components/tableComponents/VariableTextTableData'
import DeleteButton from '../../components/tableComponents/DeleteButton'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { isValidEmail, isValidUsername } from './validateInput.js'

const StyledTableRow = styled.tr`
	border-bottom: 1px solid #d6d6d6;
	height: 32px;
`

const TableRow = ({
	dataElement,
	index,
	setDataElement,
	deleteElement,
	groups,
}) => {
	const ownId = useSelector((state) => state.user.value.data.id)

	const disabled = dataElement.id === ownId

	function updateData(attribute, value) {
		setDataElement({ ...dataElement, [attribute]: value })
	}

	return (
		<StyledTableRow key={dataElement.id}>
			<FixedTextTableData text={index + 1} />
			<VariableTextTableData
				text={dataElement.username}
				setText={(newText) => updateData('username', newText)}
				disabled={disabled}
				containsValidText={isValidUsername(dataElement.username)}
			/>
			<VariableTextTableData
				text={dataElement.email}
				setText={(newText) => updateData('email', newText)}
				disabled={disabled}
				containsValidText={isValidEmail(dataElement.email)}
			/>
			<VariableTextTableData
				text={dataElement.phonenumber}
				setText={(newText) => updateData('phonenumber', newText)}
				disabled={disabled}
			/>
			<DropdownTableData
				options={groups}
				selectedOption={dataElement.group || null}
				setSelectedOption={(newOption) => updateData('group', newOption)}
				disabled={disabled}
			/>
			<DeleteButton deleteEntry={deleteElement} disabled={disabled} />
		</StyledTableRow>
	)
}

export default TableRow
